const selectedTimezones = {
    // Western Europe
    "Europe/Amsterdam": "Amsterdam",
    "Europe/Brussels": "Brussels",
    "Europe/Paris": "Paris",
    "Europe/Madrid": "Madrid",
    "Europe/Lisbon": "Lisbon",
    "Europe/London": "London",
    "Europe/Dublin": "Dublin",

    // Central Europe
    "Europe/Berlin": "Berlin",
    "Europe/Vienna": "Vienna",
    "Europe/Zurich": "Zurich",
    "Europe/Prague": "Prague",
    "Europe/Warsaw": "Warsaw",
    "Europe/Budapest": "Budapest",

    // Southern Europe
    "Europe/Rome": "Rome",
    "Europe/Athens": "Athens",

    // Nordics
    "Europe/Stockholm": "Stockholm",
    "Europe/Copenhagen": "Copenhagen",
    "Europe/Oslo": "Oslo",
    "Europe/Helsinki": "Helsinki",

    // Eastern Europe
    "Europe/Kiev": "Kyiv",
    "Europe/Bucharest": "Bucharest",
    "Europe/Sofia": "Sofia",

    // Baltics
    "Europe/Tallinn": "Tallinn",
    "Europe/Riga": "Riga",
    "Europe/Vilnius": "Vilnius",

    // Middle East (common ones)
    "Asia/Dubai": "Dubai",
    "Asia/Riyadh": "Riyadh",
    "Asia/Jerusalem": "Jerusalem",

    // Asia
    "Asia/Tokyo": "Tokyo",
    "Asia/Seoul": "Seoul",
    "Asia/Shanghai": "Shanghai",
    "Asia/Hong_Kong": "Hong Kong",
    "Asia/Singapore": "Singapore",
    "Asia/Bangkok": "Bangkok",
    "Asia/Kolkata": "Mumbai (IST)", // friendlier than “Kolkata” for many users

    // Oceania
    "Australia/Sydney": "Sydney",
    "Australia/Melbourne": "Melbourne",
    "Pacific/Auckland": "Auckland",

    // North America
    "America/New_York": "New York",
    "America/Chicago": "Chicago",
    "America/Denver": "Denver",
    "America/Los_Angeles": "Los Angeles",
    "America/Toronto": "Toronto",
    "America/Vancouver": "Vancouver",

    // South America
    "America/Sao_Paulo": "São Paulo",
    "America/Buenos_Aires": "Buenos Aires",
    "America/Santiago": "Santiago",
};

export const useTimezoneSelect = (includeAllSupportedOptions = false, timezonesObject = undefined) => {
    const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const supportedTimezones = (Intl as any).supportedValuesOf("timeZone");

    const formatTimeZone = (tz: string) => {
        const now = new Date();

        const formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: tz,
            timeZoneName: "longOffset",
        });

        const parts = formatter.formatToParts(now);
        const offset = parts.find((p) => p.type === "timeZoneName")?.value ?? "";

        const city = tz.split("/").pop()?.replace("_", " ") ?? tz;

        return `${city} (${offset})`;
    };

    const timezones = includeAllSupportedOptions ? supportedTimezones : Object.keys(timezonesObject ?? selectedTimezones).filter((tz) => supportedTimezones.includes(tz));
    const options = timezones
        .map((tz) => ({
            value: tz,
            label: formatTimeZone(tz),
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

    return { defaultTimezone, options };
};
